import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4 overflow-x-auto min-h-[420px]" }
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_4 = { class: "px-2 py-2" }
const _hoisted_5 = { class: "px-2 py-2" }
const _hoisted_6 = { class: "px-2 py-2" }
const _hoisted_7 = { class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray" }
const _hoisted_8 = { class: "px-2 py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_9 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }, "-", -1)
const _hoisted_11 = { class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray" }
const _hoisted_12 = { class: "px-2 py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_13 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }, "-", -1)
const _hoisted_15 = { class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray" }
const _hoisted_16 = { class: "px-2 py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_17 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_18 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_19 = { class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray" }
const _hoisted_20 = { class: "px-2 py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_21 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_22 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_23 = { class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray" }
const _hoisted_24 = { class: "px-2 py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_25 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }, "-", -1)
const _hoisted_27 = { class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray" }
const _hoisted_28 = { class: "px-2 py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_29 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_30 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_31 = { class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray" }
const _hoisted_32 = { class: "px-2 py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_33 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_34 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }

import { ref } from "vue";
import api from "@/api/api";
import { AggregatedGoalsData } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'AggregatedGoalsTable',
  async setup(__props) {

let __temp: any, __restore: any

const goalsData = ref([] as AggregatedGoalsData[]);

async function listEvents() {
    await api.goals.getAggregatedGoalsData().then((response: AggregatedGoalsData[]) => {
        goalsData.value = response;
    });
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listEvents())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('description')), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('number')), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('percent')), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", _hoisted_7, [
          _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('total-clubs')), 1),
          _createElementVNode("td", _hoisted_9, _toDisplayString(goalsData.value.numberOfClubs), 1),
          _hoisted_10
        ]),
        _createElementVNode("tr", _hoisted_11, [
          _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('total-club-members')), 1),
          _createElementVNode("td", _hoisted_13, _toDisplayString(goalsData.value.studentsInClubs), 1),
          _hoisted_14
        ]),
        _createElementVNode("tr", _hoisted_15, [
          _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t('total-members-meaningful')), 1),
          _createElementVNode("td", _hoisted_17, _toDisplayString(goalsData.value.studentsWithMeaningfulProgress), 1),
          _createElementVNode("td", _hoisted_18, _toDisplayString(goalsData.value.studentsWithMeaningfulProgress.length ? Math.round((goalsData.value.studentsWithMeaningfulProgress / goalsData.value.studentsInClubs) * 100) + '%' : _ctx.$t('no-data')), 1)
        ]),
        _createElementVNode("tr", _hoisted_19, [
          _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t('total-members-achieved')), 1),
          _createElementVNode("td", _hoisted_21, _toDisplayString(goalsData.value.studentsWithAchievedGoals), 1),
          _createElementVNode("td", _hoisted_22, _toDisplayString(goalsData.value.studentsWithAchievedGoals.length ? Math.round((goalsData.value.studentsWithAchievedGoals / goalsData.value.studentsInClubs) * 100) + '%' : _ctx.$t('no-data')), 1)
        ]),
        _createElementVNode("tr", _hoisted_23, [
          _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t('total-goals')), 1),
          _createElementVNode("td", _hoisted_25, _toDisplayString(goalsData.value.numberOfGoals), 1),
          _hoisted_26
        ]),
        _createElementVNode("tr", _hoisted_27, [
          _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.$t('total-goals-meaningful')), 1),
          _createElementVNode("td", _hoisted_29, _toDisplayString(goalsData.value.numberOfGoalsWithMeaningfulProgress), 1),
          _createElementVNode("td", _hoisted_30, _toDisplayString(goalsData.value.numberOfGoalsWithMeaningfulProgress.length ? Math.round((goalsData.value.numberOfGoalsWithMeaningfulProgress / goalsData.value.numberOfGoals) * 100) + '%' : _ctx.$t('no-data')), 1)
        ]),
        _createElementVNode("tr", _hoisted_31, [
          _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.$t('total-goals-achieved')), 1),
          _createElementVNode("td", _hoisted_33, _toDisplayString(goalsData.value.numberOfAchievedGoals), 1),
          _createElementVNode("td", _hoisted_34, _toDisplayString(goalsData.value.numberOfAchievedGoals.length ? Math.round((goalsData.value.numberOfAchievedGoals / goalsData.value.numberOfGoals) * 100) + '%' : _ctx.$t('no-data')), 1)
        ])
      ])
    ])
  ]))
}
}

})